import { html } from "./html";
import { temporal } from "./temporal";
import { dom } from "./dom";
export var utilities = {
    html: html,
    temporal: temporal,
    dom: dom,
};
